import { render, staticRenderFns } from "./CustomerInvoiceButton.vue?vue&type=template&id=33ad108d"
import script from "./CustomerInvoiceButton.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports